/* ==========================================================================
   Fraternal — pull-the-lever SMS pop-up (2026-10-22, Jalen; concept 4 of
   clients/fraternal/docs/popup_games_2026-10-22.html)

   Flow:  trigger (delay / desktop exit intent) -> one pull of the lever -> the
          reels spin through real tees and land on three Fraternal logos ->
          10% off shows (EVERY visitor gets the same one) -> "Claim" reveals the
          Postscript pop-up, which collects the phone number and texts the code.

   Postscript hold and lifecycle (once per visitor, cooldown after a dismiss,
   reopen tab, subscriber skip, scroll lock, instant hand-off) are a port of
   nasty_rugs theme_variant_b assets/ngs-paint-popup.js (itself One Chance's
   stopwatch, from Gibbs's Krazy Ambitions slot). Config: window.FRT_SLOT_CFG,
   written by snippets/frt-slot-config.liquid.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-frt-slot]');
  if (!root || typeof root.showModal !== 'function') return;

  var c0 = window.FRT_SLOT_CFG || {};
  function num(v, d) { var n = parseFloat(v); return isNaN(n) ? d : n; }
  var cfg = {
    enabled:      c0.enabled === true,
    popupId:      String(c0.popupId || '').trim(),
    delay:        num(c0.delay, 6),
    exitIntent:   c0.exitIntent === true,
    cooldownDays: num(c0.cooldownDays, 7),
    force:        /[?&]frt_slot=1\b/.test(location.search)
  };
  var ready = cfg.enabled && !!cfg.popupId;

  var KEY = 'frt_slot_v1';
  function readState() { try { return JSON.parse(localStorage.getItem(KEY) || 'null') || {}; } catch (e) { return {}; } }
  function writeState(patch) {
    try { var s = readState(); for (var k in patch) s[k] = patch[k]; localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {}
  }
  function emit(action, extra) {
    var d = { action: action }; if (extra) for (var k in extra) d[k] = extra[k];
    try { document.dispatchEvent(new CustomEvent('frt:slot-popup', { detail: d })); } catch (e) {}
  }

  var reduceMotion = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer  = window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---------------------------------------------------------------- gating */
  function fromOurTexts() { return /utm_source=postscript/i.test(location.search); }
  function suppressedLocally() {
    if (cfg.force) return false;
    if (!ready || fromOurTexts()) return true;
    var s = readState();
    if (s.claimed) return true;
    if (s.dismissed && Date.now() - s.dismissed < cfg.cooldownDays * 864e5) return true;
    return false;
  }
  // getSubscriberId may be sync or a promise depending on the SDK build.
  function isSubscriber(cb) {
    var ps = window.postscript, r;
    if (!ps || typeof ps.getSubscriberId !== 'function') return cb(false);
    try { r = ps.getSubscriberId(); } catch (e) { return cb(false); }
    if (r && typeof r.then === 'function') {
      var done = false;
      r.then(function (id) { if (!done) { done = true; cb(!!id); } }, function () { if (!done) { done = true; cb(false); } });
      setTimeout(function () { if (!done) { done = true; cb(false); } }, 1500);
    } else cb(!!r);
  }

  /* ------------------------------------------------------- Postscript hold
     html.frt-ps-hold (set in <head> by snippets/frt-slot-hold.liquid) keeps Postscript's frame invisible and
     click-through while unclaimed. Once the reels land we open OUR configured pop-up ourselves, still hidden, so
     it is fully drawn before Claim; Claim reveals it. */
  var holding = document.documentElement.classList.contains('frt-ps-hold');
  function holdPostscript() { if (!holding) { holding = true; document.documentElement.classList.add('frt-ps-hold'); } }
  function releaseHold() { holding = false; document.documentElement.classList.remove('frt-ps-hold'); }
  var preopened = false;
  function psOpen() {
    var ps = window.postscript;
    if (!cfg.popupId || !ps || !ps.popups || typeof ps.popups.open !== 'function') return false;
    // Options as in Postscript's own snippet for this pop-up (Jalen, 2026-10-22).
    try { ps.popups.open(cfg.popupId, { activePopupBehavior: 'ALWAYS_DISMISS', respectPopupStatus: true }); return true; } catch (e) { return false; }
  }
  function preopenPostscript() { if (holding && !preopened && psOpen()) preopened = true; }

  // Never stack on the size guide, the mobile menu, or another dialog.
  function somethingElseOpen() {
    var open = document.querySelectorAll('dialog[open]');
    for (var i = 0; i < open.length; i++) if (open[i] !== root) return true;
    var guide = document.getElementById('frt-sizeguide');
    if (guide && !guide.hidden) return true;
    if (document.querySelector('[aria-expanded="true"][aria-controls]')) return true;
    var ps = document.getElementById('ps__widget');
    if (ps && !holding) { var r = ps.getBoundingClientRect(); if (r.width > 200 && r.height > 200 && getComputedStyle(ps).visibility !== 'hidden') return true; }
    return false;
  }

  var shown = false, timer = null;
  function tryOpen() {
    if (shown) return;
    if (somethingElseOpen()) { timer = setTimeout(tryOpen, 4000); return; }
    shown = true; clearTimeout(timer); document.removeEventListener('mouseout', onExit);
    isSubscriber(function (sub) { if (sub && !cfg.force) return; open(); });
  }
  function onExit(e) {
    if (e.relatedTarget == null && e.clientY <= 0) {
      document.removeEventListener('mouseout', onExit);
      clearTimeout(timer); tryOpen();
    }
  }
  function arm() {
    if (cfg.force) { try { localStorage.removeItem(KEY); } catch (e) {} }
    var s = readState();
    if ((ready || cfg.force) && cfg.popupId && !s.claimed && !fromOurTexts()) holdPostscript();
    if (!cfg.force && s.claimed) return;
    if (tabWanted(s)) showTab(true);
    if (suppressedLocally()) return;
    setTimeout(warm, Math.max(0, cfg.delay - 3) * 1000);
    if (cfg.delay >= 0) timer = setTimeout(tryOpen, (cfg.force ? Math.min(cfg.delay, 1) : cfg.delay) * 1000);
    if (cfg.exitIntent && finePointer) document.addEventListener('mouseout', onExit);
  }

  /* --------------------------------------------------------------- elements */
  var lever   = root.querySelector('[data-slot-pull]');
  var strips  = root.querySelectorAll('[data-slot-strip]');
  var claimEl = root.querySelector('[data-slot-claim]');
  var live    = root.querySelector('[data-slot-live]');
  var won = false, claimed = false, spinning = false;
  var keyboardUser = false;
  root.addEventListener('keydown', function () { keyboardUser = true; }, true);
  root.addEventListener('pointerdown', function () { keyboardUser = false; }, true);
  function setState(s) { root.setAttribute('data-slot-state', s); }

  /* --------------------------------------------- lazy images + font (once) */
  var warmed = false;
  function warm() {
    if (warmed) return; warmed = true;
    var imgs = root.querySelectorAll('img[data-slot-src]');
    for (var i = 0; i < imgs.length; i++) { imgs[i].src = imgs[i].getAttribute('data-slot-src'); imgs[i].removeAttribute('data-slot-src'); }
    // The card's display face; the site itself only loads Anonymous Pro. Falls back to Arial Black.
    var f = document.createElement('link');
    f.rel = 'stylesheet'; f.href = 'https://fonts.googleapis.com/css2?family=Archivo+Black&display=swap';
    document.head.appendChild(f);
  }
  function logoReady(cb) {
    var img = root.querySelector('.frt-slot__logo'), done = false, finish = function () { if (!done) { done = true; cb(); } };
    setTimeout(finish, 1200);
    if (!img || img.tagName !== 'IMG') return finish();
    if (img.decode) img.decode().then(finish, finish);
    else if (img.complete) finish(); else img.onload = img.onerror = finish;
  }

  /* ------------------------------------------------------ scroll lock (html) */
  var lockPad = '';
  function lockScroll() {
    var de = document.documentElement, sb = window.innerWidth - de.clientWidth;
    lockPad = de.style.paddingRight; de.classList.add('frt-slot-lock');
    if (sb > 0) de.style.paddingRight = sb + 'px';
  }
  function unlockScroll() { var de = document.documentElement; de.classList.remove('frt-slot-lock'); de.style.paddingRight = lockPad; }

  /* ------------------------------------------------------------ open/close */
  var opening = false;
  function open() {
    if (root.open || opening) return;
    opening = true; shown = true; clearTimeout(timer);
    document.removeEventListener('mouseout', onExit);
    hideTab(); warm();
    logoReady(function () { opening = false; if (!root.open) reveal(); });
  }
  function reveal() {
    var s = readState();
    if (s.won && !won) finish(true);
    setState(won ? 'won' : 'ready');
    root.showModal(); lockScroll();
    root.focus({ preventScroll: true });
    writeState({ shown: Date.now() });
    if (won) preopenPostscript();
    emit('open', { won: won });
  }
  root.addEventListener('close', function () {
    unlockScroll();
    if (!claimed) { writeState({ dismissed: Date.now() }); emit('dismiss', { won: won }); showTab(false); }
  });
  root.addEventListener('click', function (e) {
    if (e.target === root) root.close();                           // backdrop
    if (e.target.closest('[data-slot-close]')) root.close();
  });

  /* ------------------------------------------------------------------ pull
     One tap anywhere on the lever spins all three reels to the logo tile at the end of each strip, stopping left to
     right. No skill: every pull lands the jackpot. */
  function tileH(strip) { var t = strip.firstElementChild; return t ? t.offsetHeight : 0; }
  function landAll(animated) {
    for (var i = 0; i < strips.length; i++) {
      var s = strips[i], n = s.children.length - 1, h = tileH(s);
      s.style.transition = 'none'; s.style.transform = 'translateY(0)';
      void s.offsetHeight;
      s.style.transition = animated ? 'transform ' + (1.3 + i * .45) + 's cubic-bezier(.15,.6,.25,1.04)' : 'none';
      s.style.transform = 'translateY(' + (-h * n) + 'px)';
    }
  }
  lever.addEventListener('click', function () {
    if (won || spinning) return;
    spinning = true; root.classList.add('is-pulled', 'is-spinning');
    setTimeout(function () { root.classList.remove('is-pulled'); }, 400);
    emit('start');
    var animated = !reduceMotion;
    landAll(animated);
    setTimeout(function () { spinning = false; root.classList.remove('is-spinning'); finish(false); },
      animated ? 1300 + (strips.length - 1) * 450 + 250 : 0);
  });

  function finish(instant) {
    if (won) return;
    won = true;
    if (instant) landAll(false);
    lever.setAttribute('aria-disabled', 'true');
    setState('won');
    if (instant) return;
    if (!reduceMotion && navigator.vibrate) { try { navigator.vibrate([40, 30, 80]); } catch (e) {} }
    writeState({ won: Date.now() });
    if (live) live.textContent = 'Jackpot. 10% off your first order is yours. We\'ll text you the code.';
    emit('reveal');
    preopenPostscript();
    if (keyboardUser && claimEl) claimEl.focus(); else root.focus({ preventScroll: true });
  }

  /* ----------------------------------------------------------------- claim
     Postscript's SDK can take several seconds to start (its phone pop-up loads in a second frame), and an open()
     made before it has its pop-up list is silently dropped. So Claim keeps the card up ("Opening…"), re-asks
     Postscript every 2 s, and steps aside only once Postscript's frame is actually drawn (still hidden by the
     hold, but sized). After 10 s with nothing, the card stays up and asks them to tap again. */
  var CLAIM_WAIT = 10000, RETRY_EVERY = 2000;
  function postscriptShowing() {
    var fs = document.querySelectorAll('iframe[src*="postscript.io"]'), vw = window.innerWidth, vh = window.innerHeight;
    for (var i = 0; i < fs.length; i++) {
      var r = fs[i].getBoundingClientRect();
      if (r.width > vw * 0.5 && r.height > vh * 0.5) return true;
    }
    return false;
  }
  function revealPostscript() {
    claimed = true;
    writeState({ claimed: Date.now() });
    hideTab();
    releaseHold(); root.close(); root.classList.remove('is-claiming');
  }
  claimEl.addEventListener('click', function (e) {
    e.preventDefault();
    if (root.classList.contains('is-claiming')) return;
    var note = root.querySelector('[data-slot-setup-note]'); if (note) note.hidden = true;
    root.classList.add('is-claiming');
    emit('claim', { via: preopened ? 'postscript-preopened' : 'postscript-popup' });
    var t0 = Date.now(), lastAsk = 0;
    if (!preopened && psOpen()) { preopened = true; lastAsk = t0; }
    (function check() {
      if (!root.open) return;
      if (postscriptShowing()) return revealPostscript();
      var now = Date.now();
      if (now - t0 > CLAIM_WAIT) {                                 // never close onto nothing: keep the card, ask again
        root.classList.remove('is-claiming');
        if (note) note.hidden = false;
        emit('claim-failed');
        return;
      }
      if (now - lastAsk > RETRY_EVERY && psOpen()) { preopened = true; lastAsk = now; }
      requestAnimationFrame(check);
    })();
  });

  /* ------------------------------------------------- reopen tab (bottom left) */
  var tab = document.querySelector('[data-slot-tab]');
  function tabWanted(s) {
    if (!tab || s.claimed || !s.dismissed || fromOurTexts()) return false;
    if (!ready && !cfg.force) return false;
    return !(s.tabHidden && Date.now() - s.tabHidden < cfg.cooldownDays * 864e5);
  }
  function showTab(checkSubscriber) {
    if (!tab || claimed || (!ready && !cfg.force)) return;
    tab.setAttribute('data-slot-won', (won || readState().won) ? 'true' : 'false');
    function show() { tab.hidden = false; tab._queueTuck && tab._queueTuck(); }
    if (!checkSubscriber) return show();
    isSubscriber(function (sub) { if (!sub) show(); });
  }
  function hideTab() { if (tab) tab.hidden = true; }
  if (tab) {
    tab.querySelector('[data-slot-tab-open]').addEventListener('click', function () { emit('tab-open'); if (!root.open) open(); });
    tab.querySelector('[data-slot-tab-close]').addEventListener('click', function () { writeState({ tabHidden: Date.now() }); hideTab(); emit('tab-hide'); });
    window.addEventListener('postscriptReady', function () { isSubscriber(function (sub) { if (sub) hideTab(); }); });
    // Never sit on a button: tuck off the edge while overlapping any .btn (hero CTA, add-to-cart, sticky buy bar)
    // or a way to pay.
    var BUY = '.btn, form[action*="/cart/add"] button, form[action*="/cart/add"] [type="submit"], .shopify-payment-button, ' +
              'shopify-accelerated-checkout, [class*="sticky"] button, [name="checkout"]';
    var tq = false;
    function overlaps(a, b) { return a.left < b.right && a.right > b.left && a.top < b.bottom && a.bottom > b.top; }
    function tuck() {
      tq = false; if (tab.hidden) return;
      // offset* ignore the tuck transform, so this is where the tab sits when it is showing.
      var l = tab.offsetLeft, t = tab.offsetTop, pad = { left: l - 10, right: l + tab.offsetWidth + 10, top: t - 10, bottom: t + tab.offsetHeight + 10 };
      var hit = false, els = document.querySelectorAll(BUY);
      for (var i = 0; i < els.length && !hit; i++) { var b = els[i].getBoundingClientRect(); if (b.width && b.height && overlaps(pad, b)) hit = true; }
      tab.classList.toggle('is-tucked', hit);
    }
    function queueTuck() { if (!tq) { tq = true; requestAnimationFrame(tuck); } }
    window.addEventListener('scroll', queueTuck, { passive: true });
    window.addEventListener('resize', queueTuck);
    tab._queueTuck = queueTuck;
  }

  // QA: ?frt_slot=1 forces it open from a fresh start (even while switched off); FRT_SLOT.reset() clears the visitor memory.
  window.FRT_SLOT = {
    open: function () { if (!root.open) open(); },
    reset: function () { try { localStorage.removeItem(KEY); } catch (e) {} }
  };

  arm();
})();
